import { apiClient, API_BASE_URL } from './apiClient';

const BASE = `${API_BASE_URL}/api/platform`;

export const platformSettingsAPI = {
  async getMaintenanceNotice() {
    return apiClient(`${BASE}/maintenance-notice`);
  },

  async updateMaintenanceNotice(data) {
    return apiClient(`${BASE}/maintenance-notice`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  },
};

export default platformSettingsAPI;
